import React from 'react';
import Icon from 'components/AppIcon';
import Input from 'components/ui/Input';
import Button from 'components/ui/Button';

const ACCOUNT_TYPES = ['All Types', 'Distributor', 'Retail Store', 'Dealer', 'Sub-Distributor'];
const REGIONS = ['All Regions', 'NCR', 'Luzon', 'Visayas', 'Mindanao'];
const AREAS = ['All Areas', 'Metro Manila', 'Cebu', 'Davao', 'Iloilo', 'Cagayan de Oro', 'Batangas', 'Pampanga'];
const SALESPERSONS = ['All Salespersons', 'Juan dela Cruz', 'Maria Santos', 'Pedro Reyes', 'Ana Gomez', 'Carlo Bautista'];
const STATUS = ['All Status', 'Active', 'Inactive', 'On Hold'];

export default function AccountFilters({ filters, onChange, onReset, resultCount }) {
  const handleChange = (key, value) => onChange({ ...filters, [key]: value });

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-3">
      {/* Search */}
      <div className="flex gap-2">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search by account name, address, or contact..."
            value={filters?.search}
            onChange={(e) => handleChange('search', e?.target?.value)}
          />
        </div>
        <Button variant="outline" size="default" iconName="Search" iconPosition="left" onClick={() => {}}>
          Search
        </Button>
      </div>
      {/* Filter Row */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
        {[
          { key: 'type', label: 'Account Type', options: ACCOUNT_TYPES },
          { key: 'region', label: 'Region', options: REGIONS },
          { key: 'area', label: 'Area', options: AREAS },
          { key: 'salesperson', label: 'Salesperson', options: SALESPERSONS },
          { key: 'status', label: 'Status', options: STATUS },
        ]?.map(({ key, label, options }) => (
          <div key={key} className="relative">
            <select
              className="w-full h-10 pl-3 pr-8 text-sm border border-border rounded-md bg-background text-foreground font-caption appearance-none focus:outline-none focus:ring-2 focus:ring-ring cursor-pointer"
              value={filters?.[key]}
              onChange={(e) => handleChange(key, e?.target?.value)}
              aria-label={label}
            >
              {options?.map((o) => (
                <option key={o} value={o}>{o}</option>
              ))}
            </select>
            <div className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2">
              <Icon name="ChevronDown" size={14} color="currentColor" strokeWidth={2} />
            </div>
          </div>
        ))}
      </div>
      {/* Results + Reset */}
      <div className="flex items-center justify-between">
        <span className="font-caption text-sm text-muted-foreground">
          Showing <span className="font-medium text-foreground">{resultCount}</span> accounts
        </span>
        <Button variant="ghost" size="sm" iconName="RotateCcw" iconPosition="left" onClick={onReset}>
          Reset Filters
        </Button>
      </div>
    </div>
  );
}